<script setup>
import {onMounted, ref} from 'vue';
import {authData, getLoggedUser} from '@/services/AuthService';
import clientService from '@/services/ClientService';
import {useI18n} from 'vue-i18n';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import PaymentQrCodeModal from '@/components/modals/PaymentQrCodeModal.vue';

const {t} = useI18n()
const loggedClient = ref(null);
const loggedUser = ref(null);
const paymentTerms = ref(null);
const loading = ref(true);

function openQrCodeModal(item) {
  const {reveal} = createConfirmDialog(PaymentQrCodeModal, {
    qrCodeBase64: item.payment_qr_code_base64,
    bankAccountNumber: item.bank_account_number_full,
    variableSymbol: item.variable_symbol,
  });
  reveal();
}

onMounted(async () => {
  getLoggedUser().then(response => {
    loggedClient.value = response.client;
    loggedUser.value = response;
    getPaymentTerms();
  });
})

function getPaymentTerms() {
  clientService.getPaymentTerms(loggedClient.value.id).then(response => {
    paymentTerms.value = response;
    loading.value = false;
  });
}

</script>
<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="page-section__title">
        {{t('paymentTerms.title')}}
      </div>
    </div>
    <div class="page-section__content">
      <div v-if="loading" class="text-center">
        <div class="row border-bottom"  v-for="i in 5" :key="i">
          <div class="col-12">
            <div class="row p-3">
              <div class="col-12">
                <Skeletor width="100%" height="100" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div v-for="item of paymentTerms?.items" class="row border-bottom">
          <div class="col-12">
            <div class="row p-3 justify-content-center align-items-center mb-4">
              <div class="col-12 col-md-6">
                <div class="mb-2">
                  <strong class="me-2">{{item.strategy_name}}</strong>
                  <span v-if="item.is_active" class="badge bg-primary">{{t('paymentTerms.active')}}</span>
                  <span v-if="!item.is_active" class="badge bg-secondary">{{t('paymentTerms.inactive')}}</span>
                </div>
                <div>{{t('paymentTerms.contract')}}: <strong>{{item.contract.contract_type.name}} ({{ item.contract.contractNumber }})</strong></div>
                <div>{{t('paymentTerms.bank_account_number')}}: <strong>{{item.bank_account_number_full}}</strong></div>
                <div>{{t('paymentTerms.variable_symbol')}}: <strong>{{item.variable_symbol}}</strong></div>
              </div>
              <div class="col-12 col-md-6 mt-3 mt-md-0 text-md-end">
                <button type="button" class="btn btn-primary" @click="openQrCodeModal(item)">{{t('paymentTerms.show_qr_code')}}</button>
              </div>
              <div v-if="!item.is_active" class="col-12 text-muted">
                <small>{{t('paymentTerms.payment_description')}}</small>
              </div>
            </div>
          </div>
        </div>
        <div class="page-section__title mt-5">
          {{t('paymentTerms.payment_in_other_currencies')}}
        </div>
        <div v-for="item of paymentTerms?.other_accounts" class="row border-bottom">
          <div class="col-12">
            <div class="row p-3 justify-content-center align-items-center">
              <div class="col-12">
                <div class="mb-2"><strong>{{item.currency}}</strong></div>
                <div>IBAN: <strong>{{item.iban}}</strong></div>
                <div>BIC/SWIFT: <strong>{{item.bicSwift}}</strong></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

